import { render, staticRenderFns } from "./AdminModules.vue?vue&type=template&id=27d43243&scoped=true"
import script from "./AdminModules.vue?vue&type=script&lang=js"
export * from "./AdminModules.vue?vue&type=script&lang=js"
import style0 from "./AdminModules.vue?vue&type=style&index=0&id=27d43243&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27d43243",
  null
  
)

export default component.exports